import r from"graphql-tag";import{CircleTopicFragmentDoc as a,CircleTopicBaseFragmentDoc as c,CircleRsvpQuestionFragmentDoc as n,CircleFacilitatorFragmentDoc as s,CircleTopicSessionFragmentDoc as u,CircleSeriesFragmentDoc as d,CircleTopicAuthenticatedFragmentDoc as m,CircleTopicRsvpFragmentDoc as y,CircleRsvpBaseFragmentDoc as C}from"./fragments.generated.es.js";import*as t from"@apollo/react-hooks";const i={},$=r`
    fragment CircleOnDemandFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
  countryCode
}
    `,l=r`
    query fetchUpcomingTopicsByLanguageCodes($filterByLanguageCodes: [String!]) {
  circleTopicConnection(filterByLanguageCodes: $filterByLanguageCodes) {
    totalCount
    edges {
      node {
        ...CircleTopic
      }
    }
  }
}
    ${a}
${c}
${n}
${s}
${u}`;function F(e){const o={...i,...e};return t.useQuery(l,o)}function T(e){const o={...i,...e};return t.useLazyQuery(l,o)}const g=r`
    query fetchTopics($seriesSlug: String!, $cursor: String, $limit: Int = 10) {
  circleSeriesBySlug(slug: $seriesSlug) {
    id
    name
    heroImage
    heroBackgroundColor
    description
    illustration
    shortDescription
    accessType
    topics(after: $cursor, first: $limit) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          ...CircleTopic
        }
      }
    }
    onDemand {
      edges {
        node {
          id
          slug
          name
          languageCode
          facilitators {
            ...CircleOnDemandFacilitator
          }
          video {
            durationInSeconds
            externalVideoUrl
            thumbnail
          }
        }
      }
    }
  }
}
    ${a}
${c}
${n}
${s}
${u}
${$}`;function D(e){const o={...i,...e};return t.useQuery(g,o)}function S(e){const o={...i,...e};return t.useLazyQuery(g,o)}const p=r`
    query fetchTopicsWithRsvp($seriesSlug: String!, $cursor: String, $limit: Int = 10) {
  circleSeriesBySlug(slug: $seriesSlug) {
    ...CircleSeries
    topics(after: $cursor, first: $limit) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          ...CircleTopicAuthenticated
        }
      }
    }
  }
}
    ${d}
${m}
${c}
${n}
${s}
${y}
${C}
${u}`;function L(e){const o={...i,...e};return t.useQuery(p,o)}function Q(e){const o={...i,...e};return t.useLazyQuery(p,o)}export{$ as CircleOnDemandFacilitatorFragmentDoc,g as FetchTopicsDocument,p as FetchTopicsWithRsvpDocument,l as FetchUpcomingTopicsByLanguageCodesDocument,S as useFetchTopicsLazyQuery,D as useFetchTopicsQuery,Q as useFetchTopicsWithRsvpLazyQuery,L as useFetchTopicsWithRsvpQuery,T as useFetchUpcomingTopicsByLanguageCodesLazyQuery,F as useFetchUpcomingTopicsByLanguageCodesQuery};
//# sourceMappingURL=topics.generated.es.js.map
